import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import * as Rx from 'rxjs';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MagliveApiClient } from '../../../../../lib/api-client/maglive-api-client';
import {
  LiveAddRequest,
  LiveThumbnail,
  LiveAddResponse,
  GlobalNgWord,
  MagazineNgWord
} from "../../../../../lib/entity/live";
import { catchError, tap, concatMap } from 'rxjs/operators';
import { validateCurrentTimeThanSmall, validateTooManyValues } from 'src/app/parts/validation/admin/LiveScheduledAtValidator.directive';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/env/environment';
import { AngularFirestore } from '@angular/fire/firestore';
import { containNgWordValidator } from 'src/app/parts/validation/admin/ngWordValidator.directive';
import { DeliverableMagazine } from 'src/lib/entity/magazine';
import { Router } from '@angular/router';

@Component({
  selector: 'admin-live-create',
  templateUrl: './live-create.component.html',
  styleUrls: [ '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './live-create.component.scss']
})
export class LiveCreateComponent implements OnInit {

  public defaultThumbnailUrl: string;

  // フォーム関係
  formGroup: FormGroup;
  selectedThumbnailFile: File;
  invalidThumbnailSize: boolean;
  isWaiting: boolean;
  allNgWordList: string[];
  globalNgWords$: Rx.Observable<GlobalNgWord[] | "NOT_AUTHORIZED">;

  // セレクトボックス関係
  deliverableMagazineList$: Rx.Observable<DeliverableMagazine[] | "NOT_FOUND">;
  deliverableMagazineList: DeliverableMagazine[];
  selectMagazine: DeliverableMagazine;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private afs: AngularFirestore,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (environment.name === "local") {
      this.defaultThumbnailUrl = 'https://live.stg.mag2.com/assets/images/thumbnail.png';
    } else {
      this.defaultThumbnailUrl = environment.baseURL.magliveWeb + 'assets/images/thumbnail.png';
    }

    this.formGroup = this.fb.group({
      userId: ["", Validators.required],
      magazineId: ["", [Validators.required,Validators.min(0)]],
      title: ['', [
        Validators.required,
        Validators.maxLength(40)
      ]],
      description: [null, Validators.maxLength(140)],
      broadcastType: ['0', [
        Validators.required,
        Validators.pattern("0|1")
      ]],
      scheduledAt: [{value: "", disabled: true},[validateCurrentTimeThanSmall(),validateTooManyValues()]],
      viewerSegment: ['ALL',Validators.pattern("ALL|SUBSCRIBER")],
      isScreenRotated: [false],
      isViewerCountEnabled: [true],
      isRadioMode: [false],
      broadcastBy: ['App'],
      thumbnailPath: [""],
      thumbnailURL: [this.defaultThumbnailUrl],
      creatorComment: [null, Validators.maxLength(140)]
    });

    this.getNgWord();

    this.getDeliverableMagazines();
  }

  get userId() { return this.formGroup.get('userId'); }
  get magazineId() { return this.formGroup.get('magazineId'); }
  get title() { return this.formGroup.get('title'); }
  get description() { return this.formGroup.get('description'); }
  get broadcastType() { return this.formGroup.get('broadcastType'); }
  get scheduledAt() { return this.formGroup.get('scheduledAt'); }
  get viewerSegment() { return this.formGroup.get('viewerSegment'); }
  get isScreenRotated() { return this.formGroup.get('isScreenRotated'); }
  get isViewerCountEnabled() { return this.formGroup.get('isViewerCountEnabled'); }
  get broadcastBy() { return this.formGroup.get('broadcastBy'); }
  get thumbnailPath() { return this.formGroup.get('thumbnailPath'); }
  get thumbnailURL() { return this.formGroup.get('thumbnailURL'); }
  get creatorComment() { return this.formGroup.get('creatorComment'); }
  get isRadioMode() { return this.formGroup.get('isRadioMode'); }

  getDeliverableMagazines():void {
    this.deliverableMagazineList$ = MagliveApiClient.getMagazineList();
    this.deliverableMagazineList$.subscribe(x => {
      if (x != "NOT_FOUND") {
        this.deliverableMagazineList = x;
      }
    })
  }

  getNgWord(magazineId?: number) {
    this.allNgWordList = [];
    MagliveApiClient.listGlobalNgWords()
    .subscribe( x => {
      if(x !== "NOT_AUTHORIZED") {
        x.map(ngWord => {
          this.allNgWordList.push(ngWord.word);
        })
      }
    })

    if (magazineId) {
      this.afs.collection(`magazines/${magazineId}/ng_words`)
      .valueChanges({idField: "id"})
      .subscribe(x => {
        x.map(ngWord=> {
          let magazineNgWord = ngWord as MagazineNgWord;
          this.allNgWordList.push(magazineNgWord.word);
        })
      })
    }

    this.title.setValidators([containNgWordValidator(this.allNgWordList),Validators.required, Validators.maxLength(40)]);
    this.description.setValidators([containNgWordValidator(this.allNgWordList), Validators.maxLength(140)]);
    this.creatorComment.setValidators([containNgWordValidator(this.allNgWordList), Validators.maxLength(140)]);
  }

  changeViewerCountCheckbox(event: any) {
    this.formGroup.patchValue({
      isViewerCountEnabled: !event.target.checked
    });
  }

  changeBroadcastByCheckbox(event: any) {
    this.formGroup.patchValue({
      broadcastBy: event.target.checked ? "Ext" : "App"
    });
  }

  clickThumbnailButton(event: any): void {
    event.target.value = '';
  };

  changeThumbnail(event: any): void {
    const reader = new FileReader()
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      this.selectedThumbnailFile = file;
      reader.onload = (event => {
        let image = new Image;
        image.src = reader.result as string;
        image.onload = () => {
          let factor = Math.abs(image.width / image.height - 16.0/9.0);
          const allowed = 0.015;
          this.invalidThumbnailSize = allowed <= factor;
        }
        this.formGroup.patchValue({
          thumbnailURL: reader.result
        });
      })
      reader.readAsDataURL(file);
    }
  }

  removeSelectingThumbnail(): void {
    if(this.thumbnailURL.value != this.defaultThumbnailUrl) {
      this.selectedThumbnailFile = null;
      this.invalidThumbnailSize = false;
      this.formGroup.patchValue({
        thumbnailPath: null,
        thumbnailURL: this.defaultThumbnailUrl
      });
    }
  }

  changeDeliverableMagazine(magazineId: number): void {
    this.deliverableMagazineList.forEach(magazine => { 
      if (magazine.magazineId == magazineId) {
        this.userId.patchValue(magazine.userId);
        this.selectMagazine = magazine;
      } 
    })
  }

  removeSelectMagazine(): void {
    this.selectMagazine = null;
    this.userId.patchValue("");
  }
  
  changeBroadCastType(value: number): void {
    if(value == 0) {
      this.formGroup.controls.scheduledAt.disable();
      this.formGroup.patchValue({
        scheduledAt: ""
      })
    } else {
      this.formGroup.controls.scheduledAt.enable();
    }
  }

  public storeLive() {
    if(this.isWaiting) return;
    this.isWaiting = true;
    // サムネイル登録
    let storeRequest$ = Rx.of<"NOT_AUTHORIZED" | LiveThumbnail>({
      thumbnailPath: this.thumbnailPath.value,
      thumbnailURL: this.thumbnailURL.value
    })

    if(this.thumbnailURL.value
       && this.thumbnailURL.value != this.defaultThumbnailUrl
       && this.selectedThumbnailFile) {

      const formData = new FormData();
      formData.append('file', this.selectedThumbnailFile);

      storeRequest$ = MagliveApiClient.createLiveThumbnail(
        this.magazineId.value,
        formData
      ).pipe(
        tap(response => {
          const thumbnailResult = response as LiveThumbnail;
          this.formGroup.patchValue({
            thumbnailPath: thumbnailResult.thumbnailPath,
            thumbnailURL: thumbnailResult.thumbnailURL
          });
        }),
        catchError(err => {
          this.toastr.error("サムネイル登録に失敗しました");
          setTimeout( () => {this.isWaiting = false;}, 3000);
          return Rx.throwError(err);
        })
      )
    }

    // ライブ登録
    storeRequest$.pipe(
      concatMap(storeResult => {
        const thumbnailResult = storeResult as LiveThumbnail;

        const params: LiveAddRequest = {
          userId: this.userId.value,
          magazineId: this.magazineId.value,
          title: this.title.value,
          description: this.description.value,
          thumbnailPath: thumbnailResult.thumbnailPath && thumbnailResult.thumbnailURL != this.defaultThumbnailUrl ? thumbnailResult.thumbnailPath : null,
          roomConfigId: 1,
          scheduledAt: Date.parse(this.scheduledAt.value)/1000,
          options: {
            broadcastBy: this.broadcastBy.value,
            isScreenRotated: this.isScreenRotated.value,
            isViewerCountEnabled: this.isViewerCountEnabled.value,
            secondsViewWithoutAuthority: 0,
            viewerSegment: this.viewerSegment.value,
            commentSegment: "SUBSCRIBER",
            reactionSegment: "SUBSCRIBER",
            isArchived: null,
            archiveDays: null,
            isRadioMode: this.isRadioMode.value
          }
        }

        return MagliveApiClient.addLiveInfo(params).pipe(
          catchError(() => {
            this.toastr.error("ライブ予約に失敗しました");
            setTimeout( () => {this.isWaiting = false;}, 3000);
            return Rx.EMPTY;
          }),

        );
      }),concatMap(x => {
        if (this.creatorComment.value) {
          const live = x as LiveAddResponse;
          const params = {
            userId: this.userId.value,
            message: this.creatorComment.value,
            device: null
          };
          return MagliveApiClient.createCreatorComment(live.liveId, params).pipe(
            catchError(()=> {
              this.toastr.error("固定コメントの登録に失敗しました。ライブ更新からから固定コメントを追加してください");
              setTimeout( () => {this.isWaiting = false;}, 3000);
              return Rx.EMPTY;
            })
          );
        } else {
          setTimeout( () => {this.isWaiting = false;}, 3000);
          this.toastr.success("代理予約しました");
          this.router.navigate(['admin/lives'])
        }
      })
    ).subscribe(() => {
      setTimeout( () => {this.isWaiting = false;}, 3000);
      this.toastr.success("代理予約しました")
      this.router.navigate(['admin/lives'])
    },
    error => {
      console.error(error)
      setTimeout( () => {this.isWaiting = false;}, 3000);
    }
    );
  }
}
